/**
 * Paths that require admin JWT (not user token).
 * /media/upload is admin-only on backend but not under /admin/.
 */
export function isAdminApiPath(pathOnly = '') {
  const p = String(pathOnly).split('?')[0];
  if (p.startsWith('/admin') || p.startsWith('admin/')) return true;
  if (/\/admin(\/|$)/.test(p)) return true;
  if (p === '/media/upload' || p.endsWith('/media/upload')) return true;
  return false;
}
